import { NO_PREF } from "@overbookd/preference";
// src/mime.ts
const JSON = "application/json";
const CSV = "text/csv";
const ICAL = "text/calendar";
const PDF = "application/pdf";
// src/registration.ts
const registrationSteps = {
	LOGIN: "LOGIN",
	FORM: "FORM",
	COMPLETED: "COMPLETED"
};
const hasHttpStringifiedRegistrationFormData = (step) => {
	return step.next === registrationSteps.FORM && "accountStatus" in step;
};
const hasRegistrationFormData = (step) => {
	return step.next === registrationSteps.FORM && "accountStatus" in step;
};
// src/preference.ts
const DEFAULT_PREFERENCE = {
	paperPlanning: null,
	assignment: NO_PREF,
	favoritePages: []
};
// src/image.ts
const PNG_MIME_TYPE = "image/png";
const JPEG_MIME_TYPE = "image/jpeg";
const WEBP_MIME_TYPE = "image/webp";
const GIF_MIME_TYPE = "image/gif";
const IMAGE_EXTENSIONS = [
	PNG_MIME_TYPE,
	JPEG_MIME_TYPE,
	WEBP_MIME_TYPE,
	GIF_MIME_TYPE
];
const ANIMATED_MIME_TYPES = [GIF_MIME_TYPE, WEBP_MIME_TYPE];
const IMAGE_MAX_UPLOAD_SIZE = 20971520;
const ZITADEL_IMAGE_MAX_SIZE = 524288;
const API_IMAGE_MAX_SIZE = 2097152;
export { ANIMATED_MIME_TYPES, API_IMAGE_MAX_SIZE, CSV, DEFAULT_PREFERENCE, GIF_MIME_TYPE, ICAL, IMAGE_EXTENSIONS, IMAGE_MAX_UPLOAD_SIZE, JPEG_MIME_TYPE, JSON, PDF, PNG_MIME_TYPE, WEBP_MIME_TYPE, ZITADEL_IMAGE_MAX_SIZE, hasHttpStringifiedRegistrationFormData, hasRegistrationFormData, registrationSteps };

//# sourceMappingURL=index.mjs.map